import React from "react";


const HowItWorks = ()=> {

  return (
    <div className="p-4">
      <h5> How it works? </h5>
      <ul>
        <li>Download our casual games and try to make as many points as you can. Win EarnDorado points according to your rank. </li>
        <li className="m-t-20"><strong>IMPORTANT</strong> <br/> You need to copy the ID from the game and paste it into the ED Token field and save it so the score will be sent. </li>
      </ul>

      <hr/>

      <h5> When the round will end? </h5>
      <ul>
        <li>The tournament end time is displayed on the contest page.</li>
        <li>If you ar in top 10 your points will be added automatically.</li>
        <li>The time of a round has 24h.</li>
      </ul>

      <hr/>

      <h5>How to win points? </h5>
      <ul>
        <li>Play and make a  highscore. You will see the winning board on the “Current Ranking” page.</li>
        <li>We will give points to the first 10 users.</li>
      </ul>

    </div>
  );
};

export default HowItWorks;
